import addError from '../../../utils/error.jsx';

export function request() {
    return {
        type: 'SYSTEM_SETTINGS_GET_BET_LIMIT_REQUEST'
    };
}

export function error(errors) {
    addError(errors);
    return {
        type: 'SYSTEM_SETTINGS_GET_BET_LIMIT_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'SYSTEM_SETTINGS_GET_BET_LIMIT_FINISH',
        data
    };
}
